import {
  FilterType,
  buildMandatoryProcessTasksFilter,
  useMandatoryProcessTasks,
} from 'generated/resources/datatable.graphql'
import { ProcessesProcessCategoryEnum, SelectorAccessFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { makeAccessOptions } from './makeAccessOptions'

export const ownerFilter = (
  category: ProcessesProcessCategoryEnum,
  source: ReturnType<typeof useMandatoryProcessTasks>,
  accesses: SelectorAccessFragment[]
) =>
  buildMandatoryProcessTasksFilter(source, {
    type: FilterType.Integer,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options: makeAccessOptions(accesses),
      },
    ],
    identifier: 'processesTaskList.onboardingOfFilter',
    path: 'owner',
    title: filterTitle()[category],
  })

const filterTitle = () => {
  return {
    ['custom']: i18n.t('processes.process.overview.tasks_table.custom'),
    ['onboarding']: i18n.t('processes.process.overview.tasks_table.onboarding'),
    ['offboarding']: i18n.t('processes.process.overview.tasks_table.offboarding'),
    ['training']: i18n.t('processes.process.overview.tasks_table.training'),
  }
}
